__turbopack_context__.v({
  "className": "oswald_86186944-module__cfCYna__className",
  "variable": "oswald_86186944-module__cfCYna__variable",
});
